module.exports = __webpack_public_path__ + "img/videosdk-item-4.c04c187.png";